import React, {useState, useEffect, useContext} from 'react';
import {
  TextField,
  Grid,
  Typography,
  Button,
  FormControl,
  FormHelperText,
} from '@material-ui/core';
import {Controller} from 'react-hook-form';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {useForm} from 'react-hook-form';
import {useDispatch, useSelector} from 'react-redux';
import {
  postServiceIds,
  getSubtypeList,
  postAddRateTable,
  fetchingClientId,
  ResetMessage as resetMessage,
} from '../../redux/reducers/ViewRateTable';
import * as Yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {getFormatDate} from '../../util/dateHelper';
import {ThemeContext} from '../../themes/ThemeProvider';
import {SuccessSnackbar} from '../../components/CustomSnackBar';
import PageLoader from '../../components/PageLoader';
import GuiAutoComplete from '../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../components/FormComponents/GuiTextField';

const EditRateTable = () => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  const dispatch = useDispatch();

  const [client, setClient] = useState();
  const [servicesId, setServicesId] = useState();
  const [subService, setSubservice] = useState();
  const [serviceID, setServiceID] = useState();
  const [rateData, setRateData] = useState();
  const [checkPercentValue, setCheckPercentValue] = useState(false);

  const validationSchema = Yup.object().shape({
    clientId: Yup.object().nullable().required('Client ID is required'),
    serviceId: Yup.object().nullable().required('Service ID is required'),
    subType: Yup.object().nullable().required('SubType is required'),
    feeType: Yup.object().nullable().required('FeeType is required'),
    newRate: Yup.string().nullable().required('New Rate is required'),
    effectiveDate: Yup.date()
      .nullable()
      .typeError('Invalid Date Format')
      .required('Effective Date is required'),
  });

  const initialValues = {
    effectiveDate: null,
    clientId: '',
    serviceId: '',
    subType: '',
    feeType: '',
    currentRate:
      (subService &&
        rateData &&
        rateData.sort((a, b) => {
          return b.rate_id - a.rate_id;
        }) &&
        rateData[0]?.rate_in_dollars) ||
      (rateData && rateData[0]?.rate_in_percentage) ?
        rateData[0]?.rate_in_dollars || rateData[0]?.rate_in_percentage :
        '',
    newRate: '',
  };

  const {handleSubmit, errors, control, setValue, reset} = useForm({
    mode: 'all',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });

  const {clientId, serviceId, subTypeLists, successMsg, isLoading} = useSelector(
    ({viewRateTable}) => viewRateTable,
  );
  useEffect(() => {
    setServiceID(serviceId.services);
    setRateData(
      subTypeLists?.rateTableData?.filter((a) => {
        return a.client_id == client && a.service_type_id == servicesId && a.subtype == subService;
      }),
    );
  }, [subTypeLists, subService, serviceId]);

  const onSubmit = (data) => {
    if (data.feeType.name == 'Percentage' && data.newRate > 100) {
      errors.feeType = 'Percentage should be less than 100';
      setCheckPercentValue(true);
    } else {
      dispatch(
        postAddRateTable({
          service_id: data.serviceId.service_id,
          client_id: data.clientId.client_id,
          fee_type: data.feeType.name,
          new_rate: parseFloat(data.newRate),
          effective_date: data.effectiveDate ? getFormatDate(data.effectiveDate) : '',
          sub_service_type: data.subType.sub_service_type,
        }),
      );
    }
  };

  useEffect(() => {
    if (successMsg) {
      dispatch(
        getSubtypeList({
          client_id: client,
          service_type: servicesId,
        }),
      );
    }
    reset(initialValues);
    setTimeout(() => {
      dispatch(resetMessage());
    }, 2000);
    setSubservice();
  }, [successMsg]);

  useEffect(() => {
    dispatch(fetchingClientId());
  }, []);

  const feeType = [
    {id: '1', name: 'Flat'},
    {id: '2', name: 'Percentage'},
  ];

  return (
    <div >
      <div className={classes.cardStyling}>
        <div className="mt-2">
          <Typography variant="h4" className="px-2">Add Rate Card for Client / Hospital Services</Typography>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
          <Grid container className="mt-3">
            <Grid className="px-1 form-group col-sm-6 col-xs-12 col-md-4 col-lg-3">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      {...props}
                      options={clientId?.length > 0 ? clientId : []}
                      getOptionLabel={(option) => option?.client_id}
                      getOptionSelected={(option, value) =>
                        value === undefined || value === '' || option.client_id === value.client_id
                      }
                      renderInput={(params) => (
                        <GuiTextField
                          {...params}
                          className={` ${classes.labelName} ${classes.selectLabel}`}
                          label="Client ID"
                          required
                          placeholder="Select Client ID"
                          error={errors && errors?.clientId?.message}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                        if (data !== null) {
                          dispatch(postServiceIds({client_id: data.client_id}));
                          setClient(data.client_id);
                        }
                      }}
                    />
                  )}
                  name="clientId"
                  control={control}
                />
              </FormControl>
              <FormHelperText style={{color: 'red'}} margin="dense" variant="outlined">
                {errors?.clientId?.message}
              </FormHelperText>
            </Grid>
            <Grid className="px-1 form-group col-sm-6 col-xs-12 col-md-4 col-lg-3">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      {...props}
                      options={serviceID != undefined ? serviceID : []}
                      getOptionLabel={(option) => option.service_type}
                      getOptionSelected={(option, value) =>
                        value === undefined ||
                        value === '' ||
                        option.service_type === value.service_type
                      }
                      renderInput={(params) => (
                        <GuiTextField
                          {...params}
                          className={` ${classes.labelName} ${classes.selectLabel}`}
                          label="Service ID"
                          placeholder="Select Service ID"
                          error={errors && errors?.serviceId?.message}
                          required
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                        if (data != null) {
                          setServicesId(data.service_id);
                          dispatch(
                            getSubtypeList({
                              client_id: client,
                              service_type_id: data.service_id,
                            }),
                          );
                        }
                      }}
                    />
                  )}
                  name="serviceId"
                  control={control}
                />
              </FormControl>
              <FormHelperText style={{color: 'red'}} margin="dense" variant="outlined">
                {errors?.serviceId?.message}
              </FormHelperText>
            </Grid>

            <Grid className="px-1 form-group col-sm-6 col-xs-12 col-md-4 col-lg-3">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      {...props}
                      options={
                        subTypeLists.subtypeList != undefined ? subTypeLists.subtypeList : []
                      }
                      getOptionLabel={(option) => option.sub_service_type}
                      getOptionSelected={(option, value) =>
                        value === undefined ||
                        value === '' ||
                        option.sub_service_type === value.sub_service_type
                      }
                      renderInput={(params) => (
                        <GuiTextField
                          {...params}
                          className={` ${classes.labelName} ${classes.selectLabel}`}
                          label="SubType"
                          required
                          placeholder="Select SubType"
                          error={errors && errors?.subType?.message}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                        if (data != null) {
                          setSubservice(data.sub_service_type);
                        }
                      }}
                    />
                  )}
                  name="subType"
                  control={control}
                />
              </FormControl>
              <FormHelperText style={{color: 'red'}} margin="dense" variant="outlined">
                {errors?.subType?.message}
              </FormHelperText>
            </Grid>
          </Grid>
          <Grid container>
            <Grid className="px-1 form-group col-sm-6 col-xs-12 col-md-4 col-lg-3">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      {...props}
                      options={feeType}
                      getOptionLabel={(option) => option.name}
                      getOptionSelected={(option, value) =>
                        value === undefined || value === '' || option.name === value.name
                      }
                      renderInput={(params) => (
                        <GuiTextField
                          {...params}
                          className={` ${classes.labelName} ${classes.selectLabel}`}
                          label="FeeType"
                          required
                          placeholder="Select FeeType"
                          error={errors && errors?.feeType?.message}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                      }}
                    />
                  )}
                  name="feeType"
                  control={control}
                />
              </FormControl>
              <FormHelperText style={{color: 'red'}} margin="dense" variant="outlined">
                {errors?.feeType?.message}
              </FormHelperText>
            </Grid>
            <Grid className="px-1 form-group col-sm-6 col-xs-12 col-md-4 col-lg-2">
              <Controller
                render={({value, onChange, ref}) => (
                  <TextField
                    className={`form-textfield form-textfield-label ${classes.labelName} ${classes.inputLabel}`}
                    placeholder="Current Rate"
                    margin="dense"
                    fullWidth
                    name="currentRate"
                    disabled
                    inputRef={ref}
                    value={initialValues.currentRate}
                    variant="outlined"
                    label="Current Rate"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => {
                      onChange(e.target.value);
                      setValue('currentRate', e.target.value);
                    }}
                  />
                )}
                control={control}
                name="currentRate"
              />
            </Grid>
            <Grid className="px-1 form-group col-sm-6 col-xs-12 col-md-4 col-lg-2">
              <Controller
                render={({value, onChange, ref}) => (
                  <TextField
                    className={`form-textfield form-textfield-label ${classes.labelName} ${classes.inputLabel}`}
                    placeholder="Enter New Rate"
                    margin="dense"
                    fullWidth
                    name="newRate"
                    required
                    inputRef={ref}
                    value={value}
                    variant="outlined"
                    label="New Rate"
                    error={errors && errors?.newRate?.message}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) => {
                      onChange(e.target.value);
                      setValue('newRate', e.target.value);
                      setCheckPercentValue(false);
                    }}
                  />
                )}
                control={control}
                name="newRate"
              />
              <FormHelperText style={{color: 'red'}} variant="outlined">
                {errors.newRate?.message ? errors.newRate.message : ''}
                {checkPercentValue ? (
                  <p style={{color: 'red'}}>Percentage should be less than 100</p>
                ) : (
                  ''
                )}
              </FormHelperText>
            </Grid>
            <Grid className="px-1 form-group col-sm-6 col-xs-12 col-md-4 col-lg-3">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container>
                  <Controller
                    as={
                      <KeyboardDatePicker
                        className={`${classes.labelName} ${classes.datePicker}`}
                        format="MM/dd/yyyy"
                        placeholder="MM/DD/YYYY"
                        fullWidth
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    }
                    inputVariant="outlined"
                    control={control}
                    required
                    name="effectiveDate"
                    label="Effective Date"
                    error={errors && errors?.effectiveDate?.message}
                    onChange={(date) => {
                      setValue('effectiveDate', date);
                      return {value: date};
                    }}
                    autoOk
                    margin="dense"
                  />
                </Grid>
              </MuiPickersUtilsProvider>
              <FormHelperText style={{color: 'red'}} margin="dense" variant="outlined">
                {errors?.effectiveDate?.message}
              </FormHelperText>
            </Grid>
            <Grid className="mt-2 px-1 form-group col-sm-6 col-xs-12 col-md-4 col-lg-2">
              <Button
                variant="contained"
                className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
                type="submit"
              >
                <span>Save New Rate</span>
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
      {isLoading && <PageLoader />}
    </div>
  );
};

export default EditRateTable;
